var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Large/RocketLaunch"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.35703 15.0266C8.32656 15.1477 7.56484 18 3.375 18C3.20924 18 3.05027 17.9341 2.93306 17.8169C2.81585 17.6997 2.75 17.5408 2.75 17.375C2.75 13.1852 5.60234 12.4234 5.72344 12.393C5.88433 12.3528 6.0546 12.3781 6.19679 12.4635C6.33898 12.5488 6.44144 12.6872 6.48164 12.848C6.52184 13.0089 6.49647 13.1792 6.41113 13.3214C6.32579 13.4636 6.18745 13.566 6.02656 13.6062C5.95625 13.6258 4.275 14.1172 4.02969 16.7203C6.63281 16.475 7.125 14.7969 7.14531 14.7187C7.18675 14.5581 7.29033 14.4204 7.43325 14.3361C7.57617 14.2518 7.74674 14.2277 7.90742 14.2691C8.06811 14.3106 8.20575 14.4142 8.29006 14.5571C8.37438 14.7 8.39847 14.8706 8.35703 15.0312V15.0266ZM15.6227 9.76093L15.25 10.1336V14.6906C15.2509 14.8554 15.2191 15.0187 15.1563 15.1711C15.0935 15.3235 15.0011 15.4618 14.8844 15.5781L12.2031 18.2578C12.0875 18.3743 11.95 18.4667 11.7984 18.5297C11.6469 18.5927 11.4844 18.6251 11.3203 18.625C11.1849 18.625 11.0503 18.6031 10.9219 18.5602C10.7013 18.4872 10.5056 18.354 10.3567 18.1756C10.2079 17.9973 10.1119 17.7808 10.0797 17.5508L9.66016 14.5437L6.20625 11.0898L3.20078 10.6703C2.97042 10.638 2.75365 10.5421 2.57485 10.3933C2.39605 10.2445 2.26231 10.0488 2.18867 9.8281C2.11504 9.60745 2.10444 9.37063 2.15806 9.14428C2.21168 8.91794 2.32739 8.71104 2.49219 8.54687L5.17187 5.86562C5.28818 5.74889 5.42655 5.65645 5.57891 5.59368C5.73127 5.53091 5.89459 5.49907 6.05937 5.5H10.6164L10.9891 5.12734C13.0734 3.04375 15.5852 2.9539 16.568 3.0125C16.8727 3.03102 17.1601 3.16043 17.376 3.37631C17.5919 3.5922 17.7213 3.87963 17.7398 4.18437C17.7969 5.16484 17.707 7.67656 15.6234 9.76093H15.6227ZM3.375 9.43281L6.27734 9.8375L9.36641 6.75H6.05937L3.375 9.43281ZM7.38437 10.5L10.25 13.3656L14.7383 8.87734C15.3431 8.27656 15.8124 7.55326 16.1145 6.75606C16.4166 5.95886 16.5446 5.10623 16.4898 4.25546C15.6395 4.20273 14.7877 4.33205 13.9914 4.63478C13.195 4.9375 12.4724 5.40667 11.8719 6.01093L7.38437 10.5ZM14 11.3836L10.9117 14.4719L11.318 17.375L14 14.6906V11.3836Z",
    fill: "url(#paint0_linear_259_5930)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_259_5930",
    x1: 17.7509,
    y1: 3.00098,
    x2: 2.1244,
    y2: 3.00098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E28A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#D378F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketLaunch);
export default __webpack_public_path__ + "static/media/RocketLaunch.b9613b24312cc8a62c7844d899e576b8.svg";
export { ForwardRef as ReactComponent };